module.exports = __webpack_public_path__ + "img/ic_album_black.da402d83.svg";